import { getCommonFiltersSlice } from '@iconik-io/shared-lib/src/redux/common_filters/slice';

export const searchFilterActions = getCommonFiltersSlice('search').actions;
